(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--review"
	);

	const initSlider = () => {
		const slides = document.querySelectorAll(".swiper--review .multicolumn-list__item");
		let slideEl = multicolumnSwipeEnabled
		let carousel = multicolumnSwipeEnabled.querySelectorAll(".swiper-carousel");
		let slide = multicolumnSwipeEnabled.querySelectorAll(".swiper-slide");
		let buttonNext = multicolumnSwipeEnabled.querySelector(".swiper-button-next");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});

		swiperMulticolumn = new Swiper(".swiper--review", {
			centeredSlides: false,
			slidesPerView: 1.1,
			waitForTransition: false,
			watchSlidesProgress: true,
			updateOnWindowResize: true,
			preloadImages: true,
			allowTouchMove: true,
			spaceBetween: 4,
			slidesOffsetBefore: 20,
			slidesOffsetAfter: 20,
			breakpoints: {
				576: {
					slidesPerView: 1.1,
					slidesOffsetBefore: 32,
					slidesOffsetAfter: 32,		
				},
				990: {
					slidesPerView: 2.1,
					slidesOffsetBefore: 32,
					slidesOffsetAfter: 32,	
				},
				1200: {
					slidesPerView: 3.1,
					slidesOffsetBefore: 32,
					slidesOffsetAfter: 32,	
				},
				1360: {
					slidesPerView: 3.1,
					slidesOffsetBefore: 64,
					slidesOffsetAfter: 64,	
				},
				1920: {
					slidesPerView: 4.1,
					slidesOffsetBefore: 64,
					slidesOffsetAfter: 64,	
				},
			},
			navigation: {
				nextEl: ".swiper--review--section .swiper-button-next",
				prevEl: ".swiper--review--section .swiper-button-prev",
			},
		});
	};

	const destroySlider = () => {
		const slides = document.querySelectorAll(".multicolumn-list__item");

		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		initSlider();
		// const multicolumnSection = document.querySelector(".multicolumn-section");

		// const sectionResizeObserver = new ResizeObserver((entries) => {
		// 	const [entry] = entries;

		// 	if (entry.contentRect.width < 990 && multicolumnSwipeEnabled) {
		// 		initSlider();
		// 	} else if (swiperMulticolumn) {
		// 		destroySlider();
		// 	}
		// });

		// sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	document.addEventListener("DOMContentLoaded", function () {
		initSlider();
	});
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
